import React, { PureComponent, ReactNode } from "react";
import { AppContextType, MenuName } from "../../AppContext";
import { ChordHistoryOptions } from "../../models/ChordHistoryOptions.model";
import SettingsMenuChordHistory from "../menu_options/SettingsMenuChordHistory";
import SettingsMenuKeyIdentification from "../menu_options/SettingsMenuKeyIdentification";
import CloseableModal from "./CloseableModal";

interface Props {}
interface State {}

export default class MenuPopup extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  constructor(props: Props) {
    super(props);
    this.state = {
      demoSliderOption: 0,
    };
  }

  handleCloseModal = () => {
    this.context.dispatch({ type: "HideMenu" });
  };

  handleUpdateSettings = (settings: Partial<ChordHistoryOptions>) => {
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: settings });
  };

  render(): ReactNode {
    return this.context.showMenu ? (
      <CloseableModal onClose={this.handleCloseModal}>
        {this.context.menuName === MenuName.ChordHistoryOptions && <SettingsMenuChordHistory />}
        {this.context.menuName === MenuName.KeyIdOptions && <SettingsMenuKeyIdentification />}
      </CloseableModal>
    ) : undefined;
  }
}

MenuPopup.contextType = AppContextType;
